/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 11:27:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-03-06 09:56:59
 */
export default {
  // 登录
  login: '/yangtse/admin/user/login',
  getMenu: '/security/identify/menu/query/user/tree',
  tencentUpload: '/third/api/tencentUpload/upload/file/local',
  userIsSuper: '/yangtse/admin/user/is/super',
}
